import { IProjectsResponseDto } from "@kuika/kuika-cl-model/src/dtos/projects-response";

export type ProjectEntryScreenSource = Pick<IProjectsResponseDto, "lastVisitedScreenId" | "defaultScreenDesignId">;

/**
 * The screen an app opens on: where this user left it, else its default screen. Lower-cased
 * because the designer's `/sd/:sdId` route and its screen lookups compare ids in lower case.
 * The Apps table and the header's app switcher both open apps through this, so the two can
 * never land on different screens.
 */
export const getProjectEntryScreenId = (project: ProjectEntryScreenSource): string =>
  (project.lastVisitedScreenId ?? project.defaultScreenDesignId).toLowerCase();
